export default "__VITE_ASSET__e47c137a__"